import angular from 'angular';

(function () {
    'use strict';

    angular.module('app.link_request').config(routesConfig);

    routesConfig.$inject = ['$stateProvider'];

    /* @ngInject */
    function routesConfig($stateProvider) {
        $stateProvider
            .state('app.link_request', {
                abstract: true,
                component: 'contentLayout',
            })
            .state('app.link_request.buyer', {
                url: '/invitedentity/:legalEntityId/:id/buyer-link-request',
                views: {
                    content: {
                        component: 'kissLinkRequestList',
                    },
                },
                resolve: {
                    connexions: getLinkRequests,
                    legalEntity: getInvitedEntityBuyer,
                    sens: function () {
                        return "BUYER";
                    },
                },
            })

            .state('app.link_request.seller', {
                url: '/seller/:id/:principalId/seller-link-request',
                views: {
                    content: {
                        component: 'kissLinkRequestList',
                    },
                },
                resolve: {
                    connexions: getSellerLinkRequests,
                    legalEntity: getLegalEntity,
                    principal: getPrincipal,
                    sens: function () {
                        return "SELLER";
                    },
                },
            });

        getLinkRequests.$inject = ['$transition$','linkRequestSvc','InvBuyerLinkRequestFilter'];
        function  getLinkRequests($transition$,linkRequestSvc ,InvBuyerLinkRequestFilter){
            return linkRequestSvc.getLinkRequests($transition$.params().legalEntityId ,new InvBuyerLinkRequestFilter(), "BUYER");
        }

        getSellerLinkRequests.$inject = ['$transition$','linkRequestSvc','InvBuyerLinkRequestFilter'];
        function  getSellerLinkRequests($transition$,linkRequestSvc ,InvBuyerLinkRequestFilter){
            return linkRequestSvc.getLinkRequests($transition$.params().id ,new InvBuyerLinkRequestFilter(), "SELLER") ;
        }

        getInvitedEntityBuyer.$inject=['$transition$', 'invitedEntitySvc']
        function getInvitedEntityBuyer($transition$, invitedEntitySvc) {
            return invitedEntitySvc.getInvitedEntityBuyer($transition$.params().id);
        }

        getPrincipal.$inject = ['PrincipalSvc','$transition$'];
        function getPrincipal(PrincipalSvc, $transition$) {
            return PrincipalSvc.getPrincipal($transition$.params().principalId);
        }

        getLegalEntity.$inject = ['PrincipalSvc', '$transition$'];
        function getLegalEntity(PrincipalSvc, $transition$) {
            return PrincipalSvc.getLegalEntity($transition$.params().principalId, $transition$.params().id);
        }


    }
})();
